<template>
  <s-modal
    v-model="showModal"
    class="recognize-alarm-modal"
    ok-confirm-message-code="MC017"
    size="lg"
    :confirm-type="confirmationTypes.YES_NO"
    :ok-title="$t('general.confirm')"
    :ok-promise="callRecognizeMethod"
    :is-loading="loading"
    @cancel="cancel"
    @shown="clearFields"
    @toggle-message="toggleHeader"
  >
    <template #modal-header v-if="showHeader">
        <alarm-header-modal
          :title="modalTitle"
          :company="alarm.companyName"
          :regional="alarm.regionalName"
          :installation="alarm.installationName"
          :asset="alarm.assetName"
        />
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="cancel"
        >
          &times;
        </button>
    </template>
    <strong class="recognize-alarm-modal__alarm-data-title">
      {{ $t('alarms-and-warnings.recognition.alarm-data') }}:
    </strong>
    <recognize-alarm-data
      class="border p-2 rounded mb-3"
      :alarm="alarm" />
    <div class="recognize-alarm-modal__info-container">
      <span class="recognize-alarm-modal__title">
        {{ $t('monitoring.comments-label') }}
      </span>
    </div>
    <b-form-textarea
      v-model="description"
      maxlength="400"
      :rows="3"
      :max-rows="6"
    >
    </b-form-textarea>
    <div
      v-if="alarm.offlineAlarm"
      class="d-flex justify-content-end mt-2"
      data-test="offline-checkbox-wrapper"
    >
      <b-checkbox v-model="ignore">
        {{ $t('alarms-and-warnings.ignore-event') }}
      </b-checkbox>
      <info-badge
        class="ml-2"
        data-test="offline-checkbox-badge"
        translation-key="alarms-and-warnings.ignore-event-tooltip"
        placement="top"
      />
    </div>
  </s-modal>
</template>

<script>
import translate from '@/services/translate';
import MonitoringService from '@/domain/services/generalPanel/dashboard';
import WaitManager from '@/services/waitManager';
import InfoBadge from '@/components/icon/InfoBadge';
import confirmationTypes from '@/constants/confirmationTypes';
import AlarmHeaderModal from '@/domain/components/generalPanel/alarmsAndWarnings/recognizeAlarmModal/AlarmHeaderModal';
import RecognizeAlarmData from './AlarmData';

export default {
  name: 'RecognizeAlarmModal',
  props: {
    alarm: {
      type: Object,
      required: true,
    },
  },
  components: {
    AlarmHeaderModal,
    InfoBadge,
    RecognizeAlarmData,
  },
  data: () => ({
    description: null,
    waitManager: null,
    ignore: false,
    showModal: false,
    loading: false,
    confirmationTypes,
    showHeader: true,
  }),
  computed: {
    modalTitle() {
      return this.alarm.recognized
        ? translate('alarms-and-warnings.recognition.recognition-information')
        : translate('alarms-and-warnings.recognition.recognize-alarm');
    },
  },
  methods: {
    toggleHeader() {
      this.showHeader = !this.showHeader;
    },
    clearFields() {
      this.description = null;
      this.ignore = false;
    },
    callRecognizeMethod() {
      this.loading = true;

      return MonitoringService.recognizeAlarm({
        alarmId: this.alarm.id,
        description: this.description,
        ignore: this.ignore,
      })
        .then((response) => {
          this.$pushAlert({ code: 'MS010' });
          const event = {
            ...response,
            recognizedComment: this.description,
            ignored: this.ignore,
          };
          this.$emit('recognizedAlarm', event);
          this.waitManager.accept(event);
        })
        .catch(() => {
          this.waitManager.reject();
        })
        .finally(() => {
          this.showModal = false;
          this.loading = false;
        });
    },
    show() {
      this.showModal = true;
      this.showHeader = true;
      this.waitManager = new WaitManager();
      return this.waitManager.waiter;
    },
    cancel() {
      this.waitManager.reject();
      this.showModal = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  .recognize-alarm-modal
    width: 550px
    &__title
      font-weight: bold
    &__alarm-data-title
      color: var(--color-primary)
    &__info-container
      margin-bottom: 5px
      &_horizontal
        display: flex
        flex-direction: column
</style>
